import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { translate } from 'utils/index';
import { messages } from 'pages/Organization/messages';
import { removeOrganizationProfile } from 'api/organizations';
import ActionIcons from 'pages/Organization/actionIcons';
import NewRemoveConfirmationModal from 'components/NewRemoveConfirmationModal';

import './index.scss';

const OrgEditActions = ({ orgId, profileId, orgIndex, userName, ...otherProps }) => {
  const dispatch = useDispatch();
  const [showPopup, setShowPopup] = useState({
    edit: false,
    remove: false,
  });
  const [loading, setLoading] = useState(false);

  const onClickCancel = () => {
    setShowPopup(() => ({
      edit: false,
      remove: false,
    }));
  };

  const setPopupState = ({ target: { title } }) => {
    setShowPopup((state) => ({ ...state, [title]: !state[title] }));
  };

  const removeUser = async () => {
    setLoading(true);
    await dispatch(removeOrganizationProfile({ profileId, orgId, orgIndex }));
    setLoading(false);
  };

  return (
    <>
      <ActionIcons removeOnClick={setPopupState} {...otherProps} />
      <div className="organization-edit-page__actions">
        <NewRemoveConfirmationModal
          open={showPopup.remove}
          text={translate(messages.orgSettingsRemoveUserDescription, { userName })}
          title={translate(messages.orgSettingsRemoveUserTitle, { userName })}
          onCancel={onClickCancel}
          onOk={removeUser}
          confirmLoading={loading}
        />
      </div>
    </>
  );
};

OrgEditActions.propTypes = {
  orgId: PropTypes.string,
  orgIndex: PropTypes.string,
  profileId: PropTypes.string,
  userName: PropTypes.string,
};

export default OrgEditActions;
